import React, { useState, useEffect } from 'react';

import SecurityMan from '../../assets/images/security-man.svg';
import Container from '@material-ui/core/Container';
import Icon from '@material-ui/core/Icon';

import ConfidentTermsText from './ConfidentTermsText';
import FirstBox from './FirstBox';


const ConfidentTermBox = ({ clientData,  handleClickTerms, isLoadingTermsButton, errorRequestTermsPage }) => {
    const [hrefMessage, setHrefMessage] = useState('moreText');
    const [readMore, setReadMore] = useState(false);

    const today = new Date();

    const handleClickReadMore = (e) => {
        e.preventDefault();
        setReadMore(!readMore);
    }

    useEffect(() => {
        if (readMore) {
            setHrefMessage('lessText');
        } else {
            setHrefMessage('moreText');
        }
    }, [readMore]);

    return (
        <div className="container-form-4 general-container" style={{ textAlign: 'justify' }}>
            <Container>
                <div className="row d-flex justify-content-center m-3">
                    <img src={SecurityMan} alt="security-man" style={{ width: 129 }}/>
                </div>
                <br />
                <Container>
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <h5 className="title-9 m-0 bold-color">Acuerdo de confidencialidad</h5>
                            <br/>
                            <h6 className="text-4 m-0 w-100 text-center">Para continuar debe aceptar los términos de confidencialidad.</h6>
                            <br/>
                            <br/>
                        </div>
                        <div className="col-12">
                            <h5 className="title-2 text-black text-center m-0">
                                ACUERDO DE CONFIDENCIALIDAD Y NO DIVULGACIÓN ENTRE TEAMCORE SOLUTIONS SpA Y {clientData.company_real_name.toUpperCase()}
                            </h5>
                        </div>
                    </div>
                </Container>
                <br />
                <div className="row">
                    <div className={`col-12 ${readMore ? '' : 'scrollbar-content'}`}>
                        <ConfidentTermsText clientData={clientData} today={today} />
                    </div>
                </div>
                <br />
                <div className="row d-flex justify-content-center">
                    <a
                        className="text-link text-underline"
                        onClick={handleClickReadMore}
                        href={hrefMessage}
                    >
                        {!readMore
                            ? 'Seguir leyendo '
                            : 'Ver menos '
                        }
                        {readMore
                            ? <Icon className="fas fa-chevron-up" style={{ fontSize: 10 }}></Icon>
                            : <Icon className="fas fa-chevron-down" style={{ fontSize: 10 }}></Icon>
                        }
                    </a>
                </div>
                <FirstBox
                    handleClickTerms={handleClickTerms}
                    isLoadingTermsButton={isLoadingTermsButton}
                    errorRequestTermsPage={errorRequestTermsPage}
                />
            </Container>
        </div>
    );
};

export default ConfidentTermBox;
